import React, {Component} from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Button from '../../../shared/components/Button';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';


import { alphabeticallySort,textContains } from '../../../shared/utils';
import moment from "moment";

class AffiliatesList extends Component {
  constructor(props){
    super(props);

    this.state = {
      isLoading:false
    }
  }

  componentDidMount(){
      if(!this.props.shouldLoad) {
          return
      }
    this.setState({isLoading:true});
    Promise.all([
        this.props.loadBrands(),
        this.props.loadAffiliates()
    ])
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  render(){
    const { affiliates, brandId } = this.props;
    if (this.state.isLoading) {
        return <div>Loading...</div>
    }
    return (
        <div>
          <Row>
            <Col xs='12'>
              <SearchableDataTable
                  items={affiliates}
                  searchPromptText='Search by name'
                  emptyText='There are no affiliates'
                  columns={[
                    {
                      display:`${brandId ? 'Affiliate Name': 'Brand Name'}`,
                      name:'name',
                      width:20,
                      sortFunc:(a,b) => brandId ? alphabeticallySort(a.name,b.name) : alphabeticallySort(a.brand.name,b.brand.name),
                      filterFunc:(a,searchParam) => brandId ? textContains(a.name,searchParam) : textContains(a.brand.name,searchParam),
                      renderCell:(item) => (
                          <div>
                              {brandId ?
                                  <Link to={`${this.props.match.url}/${item.id}`}>{item.name}</Link>
                              : item.brandId ? <Link to={`/superadmin/brands/${item.brandId}/edit`}>{item.brandName}</Link>
                                      : item.brandName
                              }

                          </div>
                      )
                    },
                      {
                          name:'priority',
                          width:10,
                          sortFunc:(a,b) => (a.priority > b.priority),
                          renderCell:(item) => (
                              <div>
                                  <span>{item.priority}</span>
                              </div>
                          )
                      },
                    {
                      name:'status',
                      width:10,
                        sortFunc:(a,b) => alphabeticallySort(a.status,b.status),
                      renderCell:(item) => (
                          <div>
                            <span>{item.status}</span>
                          </div>
                      )
                    },
                    {
                      name:'startDate',
                      display:'Start Date',
                      width:15,
                      sortFunc:(a,b) => a.startDate - b.startDate,
                      renderCell:(item) => <span>{moment(item.startDate).format('MMM D, YYYY')}</span>
                    },
                    {
                      name:'endDate',
                      display:'End Date',
                      width:15,
                      sortFunc:(a,b) => a.endDate - b.endDate,
                      renderCell:(item) => <span>{item.endDate ? moment(item.endDate).format('MMM D, YYYY') : '-'}</span>
                    },{
                          name:'url',
                          display:'URL',
                          width:20,
                          renderCell:(item) => (
                              <div className='affiliate-url-nowrap'>
                                  <a href={item.url} target="_blank">{item.url}</a>
                              </div>
                          )
                      },{
                      width:10,
                      renderCell:(item) => (
                          <div className='pull-right'>
                              {item.brand.id &&
                              <Button
                                  size='sm'
                                  linkHref={`/superadmin/brands/${item.brandId}/affiliates/${item.id}`}
                                  textColor='#666666'
                                  borderColor='#cccccc'
                                  backgroundColor='#fff'
                              >
                                  Edit
                              </Button>
                              }
                              &nbsp;&nbsp;
                          </div>
                      )
                    }
                  ]}
              />
              <br />
              <br />
              <br />
            </Col>
          </Row>
        </div>
    )
  }
}

export default AffiliatesList;



// WEBPACK FOOTER //
// ./src/routes/AffiliatesList/components/AffiliatesList.js